import $ from 'jquery'

import MapsBase from 'scripts/components/maps/base'

class DepartmentMap extends MapsBase {
  static componentName = 'department-map'

  static DOMEvents = {
    click: 'onElementClick'
  }

  onElementClick () {
    this.showStoreList()
  }
}

export default ($el) => new DepartmentMap($el, $el.data())
export { DepartmentMap as Component }
